import React from 'react';
import { Loading as LoadingIcon } from '@nike/nike-design-system-icons';
import { StyledLoaderDiv } from './styles';

const Loading = () => (
  <StyledLoaderDiv>
    <LoadingIcon size="l" />
  </StyledLoaderDiv>
);

export default Loading;
